// extracted by mini-css-extract-plugin
export default {"card":"SidebarUserCard_card__qu4e-","meta":"SidebarUserCard_meta__wfGgb","name":"SidebarUserCard_name__o9K8o"};